import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";
import moment from "moment-timezone";

export class ProxyService {

    async transformRequestsDropdown(promise: Promise<any>) {
        const data = await promise
        const formattedData = data.map((el: IDropdownOption) => {
            const regex = /Date\((.*)\)/;
            const dateMatch = el.description!.match(regex);
            const offsetDate = moment.utc(dateMatch ? (dateMatch[1] || "") : "").tz('Europe/Sofia');
            let formattedDate = "";
            if(dateMatch && dateMatch[1].includes(" ")){
                formattedDate = offsetDate.format('DD.MM.YYYY HH:mm');
            }else{
                formattedDate = offsetDate.format('DD.MM.YYYY');
            }
            el.description = el.description!.replace(dateMatch ? (dateMatch[0] || "") : "", formattedDate);
            return el;
        })
        return formattedData;
    }

}
